export const ALL = 'ALL'
export const SETTINGS_TOKEN = 'SETTINGS_TOKEN'
export const BLOCKED_TOKEN = 'BLOCKED_TOKEN'

export const KEYCRM_TOKEN = 'KEYCRM_TOKEN'
